import FeaturesCodes from "~/utils/product-features-codes";

export const productAdditionalDetailsProps = () => ({
  features: {
    type: Array,
    required: false,
    default: () => []
  },
  feature: {
    type: Object,
    required: false,
    default: null
  },
  isPft: {
    type: Boolean,
    required: false,
    default: false
  },
  legalGuarantee: {
    type: String,
    required: false
  }
})

export const useProductAdditionalDetails = (props) => {
  const informationsValuesByGroup = computed(() => {
    const informationsValuesByGroup = [];
    if (props.feature && props.feature.groups.length > 0) {
      props.feature.groups.map((group) => {
        const values = [];
        group.values.map((e) => {
          values.push(e)
        });
        informationsValuesByGroup.push({ groupLabel: group.label, code: group.code, values })
      });
    }
    return informationsValuesByGroup;
  })
  const groupValues = computed(() => {
    const origineValues = [];
    if (props.feature && props.feature.groups.length > 0) {
      props.feature.groups.map((group) => {
        group.values.map((value) => {
          origineValues.push({ label: value.label, value: value.value })
        });
      });
      return origineValues;
    }
  })
  const featuresToDisplay = computed(() => {
    const featuresToDisplay = [];
    props.features.forEach(feature => {
      if (
        (props.isPft && feature.type === FeaturesCodes.SAISON) ||
        feature.type !== FeaturesCodes.SAISON
      ) {
        featuresToDisplay.push(feature);
      }
    });
    return featuresToDisplay;
  })
  const getIconName = (featureType) => {
    switch (featureType) {
      case FeaturesCodes.ORIGINE:
        return "track";
      case FeaturesCodes.SAISON:
        return "leaf-tree";
      case FeaturesCodes.PECHE:
        return "fish";
      case FeaturesCodes.COMPOSITION:
        return "search";
      case FeaturesCodes.CRACTERISTIQUES:
        return "caracteristic";
      case FeaturesCodes.COMPLEMENTAIRES:
        return "more-circle";
      case FeaturesCodes.DOCUMENTS:
        return "document";
      case FeaturesCodes.PHYTO:
        return "pharmacy";
      case FeaturesCodes.EMPLOI:
        return "help-circle-outline";
      case FeaturesCodes.CONSEILS:
        return "trick-circle-outline";
      case FeaturesCodes.LEGALES:
        return "info-circle";
      case FeaturesCodes.MARQUE:
        return "cora-circle-outline";
      case FeaturesCodes.INDICE_REPARABILITE:
        return "indice-reparabilite";
      case FeaturesCodes.CLASSE_ENERGETIQUE:
        return "classe-energetique";
      default:
        return "";
    }
  }

  return {
    informationsValuesByGroup,
    groupValues,
    featuresToDisplay,
    getIconName
  }
}